import { Component, OnInit } from '@angular/core';
import { ResearcherService, MessageQueService } from '../../services/index';

@Component({
  selector: 'app-special-instruction',
  templateUrl: 'specialInstruction.component.html',
  styleUrls: ['specialInstruction.component.scss'],
  providers: [ResearcherService, MessageQueService]
})

export class SpecialInstructionComponent implements OnInit {
  admission: string;
  researchInstruction: string;
  requestNumber: string;
  showAdmissionSection: Boolean;
  showResearchSection: Boolean;

  constructor(private researcherService: ResearcherService, private msgSvc: MessageQueService) {
      this.requestNumber = localStorage.getItem('requests');
  }
  ngOnInit() {
    this.msgSvc.setControlKey();
    this.getInstructionData();
  }
  getInstructionData() {
    this.showAdmissionSection = true;
    this.researcherService.getSpecialInstructions(this.requestNumber)
      .subscribe(
        (data) => {
          this.admission = data.admission;
          this.researchInstruction = data.researchInstruction;

          if (this.admission === '' || this.admission === undefined || this.admission === null) {
            if (this.researchInstruction !== '' || this.researchInstruction !== undefined || this.researchInstruction !== null) {
              this.admission = data.researchInstruction;
              this.researchInstruction = '';
              this.showResearchSection = false;
            } else {
              this.showResearchSection = true;
            }
          } else {
            if (this.researchInstruction !== null) {
              this.showResearchSection = true;
            } else {
              this.showResearchSection = false;
            }
          }
        });
  }
  close() {
    window.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/specialInstruction/specialInstruction.component.ts